import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-redirect',
  templateUrl: './home-redirect.component.html',
  styleUrls: ['./home-redirect.component.scss']
})
export class HomeRedirectComponent implements OnInit {
  href = new URL(window.location.href);

  constructor() { }

  ngOnInit() {
    window.location.href = environment.configs.appHost;
  }

}
